// src/utils/cfAccess.js

// CRA에서는 REACT_APP_* 환경변수만 노출됨
const TEAM_DOMAIN =
  process.env.REACT_APP_CF_TEAM_DOMAIN || "everyoungpp.cloudflareaccess.com";

// 로컬 강제 플래그 (개발 환경에서만 강제로 토큰 인증 쓰고 싶을 때)
const FORCE_LOCAL = process.env.REACT_APP_FORCE_LOCAL_AUTH === "1";

/**
 * 운영(prod) 환경 여부 판단
 * - 로컬(127.0.0.1, localhost 등)은 무조건 false
 * - FORCE_LOCAL=1이면 무조건 false
 * - 그 외에 *.everyoungpeople.com / *.pages.dev / *.netlify.app 는 true
 */
export const isProdHosted = () => {
  const host = typeof window !== "undefined" ? window.location.hostname : "";

  const isLocal =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "0.0.0.0" ||
    host === "::1";

  if (isLocal || FORCE_LOCAL) return false;

  // 운영 취급 도메인(필요시 추가 가능)
  const isKnownProd =
    /(^|\.)everyoungpeople\.com$/.test(host) ||
    /\.pages\.dev$/.test(host) ||
    /\.netlify\.app$/.test(host);

  return isKnownProd;
};

// Cloudflare Access 로그인 URL
export const cfLoginUrl = (returnTo = window.location.href) =>
  `https://${TEAM_DOMAIN}/cdn-cgi/access/login?redirect_url=${encodeURIComponent(
    returnTo
  )}`;

// Cloudflare Access 로그아웃 URL (주의: 파라미터 이름은 returnTo)
export const cfLogoutUrl = (returnTo = window.location.href) =>
  `https://${TEAM_DOMAIN}/cdn-cgi/access/logout?returnTo=${encodeURIComponent(
    returnTo
  )}`;

// 실제 이동 함수들
export const cfLogin = (returnTo) => {
  if (isProdHosted()) {
    window.location.replace(cfLoginUrl(returnTo));
  }
};

export const cfLogout = (returnTo) => {
  if (isProdHosted()) {
    window.location.replace(cfLogoutUrl(returnTo));
  }
};
